export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Zoeken',
  marketplaceDetailsCurtainCopyOptionTitle: 'Kopieer link',
  marketplaceDetailsCurtainFlagOptionTitle: 'Meld inhoud',
  marketplaceDetailsCurtainCopiedAlertText: 'Link gekopieerd!',
  marketplaceDetailsFlagCurtainTitle: 'Melding',
  marketplaceReportedCurtainContent: 'Inhoud gemeld',
  marketplaceAllItems: 'Alle items',
  marketplaceWantToBuy: 'Wil {item} kopen van {appname}'
}
